(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ven-med-style"] && !Shopify.designMode) return;
  try {
    (() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  let frame = 0;
  const update = () => {
    frame = 0;
    document.querySelectorAll('[data-med-motion]').forEach(el => {
      const img=el.querySelector('img'); if(!img) return;
      const rect=el.getBoundingClientRect();
      const active=!reduce.matches && window.innerWidth>=750 && rect.bottom>0 && rect.top<window.innerHeight;
      img.style.translate=active?`0 ${Math.max(-9,Math.min(9,(window.innerHeight/2-rect.top-rect.height/2)*.025))}px`:'0 0';
    });
  };
  const schedule=()=>{if(!frame)frame=requestAnimationFrame(update);};
  window.addEventListener('scroll',schedule,{passive:true});
  window.addEventListener('resize',schedule,{passive:true});
  document.addEventListener('shopify:section:load',schedule);
  reduce.addEventListener('change',schedule);
  schedule();
})();
  } catch(e) { console.error(e); }
})();

})();
